/* int-quiz.js · Find your Word, in the theme (Claude for Nils, 2026-10-05)
   Scoring mirrors INTENTION_Shared/quiz-rebuild-2026-10-05/score.py line for line:
   main Word 2 points, support 1 point, hero = most points, ties broken by the latest answer
   (main first, then any appearance), then alphabetical. Never chance. */
(function () {
  'use strict';
  var root = document.getElementById('int-quiz');
  if (!root || root.__intq) return;
  root.__intq = true;

  function parse(id) { var el = document.getElementById(id); try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var QS = parse('int-quiz-questions') || [];
  var WORDS = parse('int-quiz-words') || {};
  var CFG = parse('int-quiz-config') || {};
  /* the Liquid t filter HTML-escapes its value (an apostrophe arrives as &#39;), so decode once here,
     then esc() escapes exactly once at render time */
  function decode(v) { var t = document.createElement('textarea'); t.innerHTML = String(v == null ? '' : v); return t.value; }
  var S = {}; Object.keys(CFG.strings || {}).forEach(function (k) { S[k] = decode(CFG.strings[k]); });
  var LOC = CFG.locale || 'en';
  function L(obj) { return (obj && (obj[LOC] || obj.en)) || ''; }

  var screens = {};
  Array.prototype.forEach.call(root.querySelectorAll('[data-screen]'), function (el) { screens[el.getAttribute('data-screen')] = el; });
  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].hidden = (k !== name); });
    /* opened in place (assets/int-quiz-open.js, 2026-10-06): scroll the layer, never the page behind it */
    var layer = root.closest ? root.closest('[data-intq-scroll]') : null;
    if (layer) { try { layer.scrollTo({ top: 0, behavior: name === 'intro' ? 'auto' : 'smooth' }); } catch (e) { layer.scrollTop = 0; } return; }
    var top = root.getBoundingClientRect().top + window.pageYOffset - 24;
    if (name !== 'intro') window.scrollTo({ top: top, behavior: 'smooth' });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(t, a, b) { return String(t || '').replace('{a}', '<em>' + esc(a) + '</em>').replace('{b}', '<em>' + esc(b) + '</em>'); }

  /* ---------- draw: 5 text + 3 picture per visit, pictures at fixed positions ---------- */
  function shuffle(arr) { var a = arr.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function draw() {
    var d = CFG.draw || { text: 5, picture: 3, picturePositions: [2, 5, 8] };
    var text = shuffle(QS.filter(function (q) { return q.kind !== 'picture'; })).slice(0, d.text);
    var pics = shuffle(QS.filter(function (q) { return q.kind === 'picture'; })).slice(0, d.picture);
    var out = [], ti = 0, pi = 0, n = d.text + d.picture;
    for (var pos = 1; pos <= n; pos++) {
      if (d.picturePositions.indexOf(pos) !== -1 && pi < pics.length) out.push(pics[pi++]);
      else if (ti < text.length) out.push(text[ti++]);
      else if (pi < pics.length) out.push(pics[pi++]);
    }
    return out;
  }

  /* ---------- scoring ---------- */
  function score(answers) {
    var pts = {}, lastMain = {}, lastAny = {};
    answers.forEach(function (a, i) {
      a.words.forEach(function (w, j) {
        pts[w] = (pts[w] || 0) + (j === 0 ? 2 : 1);
        lastAny[w] = i;
        if (j === 0) lastMain[w] = i;
      });
    });
    var ranked = Object.keys(pts).sort(function (x, y) {
      return (pts[y] - pts[x]) ||
        ((lastMain[y] == null ? -1 : lastMain[y]) - (lastMain[x] == null ? -1 : lastMain[x])) ||
        ((lastAny[y] == null ? -1 : lastAny[y]) - (lastAny[x] == null ? -1 : lastAny[x])) ||
        (x < y ? -1 : x > y ? 1 : 0);
    });
    return { top: ranked.slice(0, 3), pts: pts };
  }
  function explain(answers, hero) {
    var mains = answers.filter(function (a) { return a.words[0] === hero; }).reverse();
    var anys = answers.filter(function (a) { return a.words[0] !== hero && a.words.indexOf(hero) !== -1; }).reverse();
    var all = answers.slice().reverse();
    var picks = [], seen = [];
    mains.concat(anys, all).forEach(function (a) { if (picks.length < 2 && seen.indexOf(a) === -1) { seen.push(a); picks.push(a); } });
    return picks;
  }
  window.__intQuizScore = score; /* exposed for the acceptance test, nothing else reads it */

  /* ---------- state ---------- */
  var visit = [], answers = [], idx = 0;

  /* ---------- intro ---------- */
  function renderIntro() {
    var friend = '';
    var m = /[?&]w=([a-z0-9-]+)/i.exec(location.search);
    if (m) {
      var fw = null;
      Object.keys(WORDS).forEach(function (t) { if (WORDS[t].key === m[1].toLowerCase() || WORDS[t].handle === 'word-' + m[1].toLowerCase()) fw = t; });
      if (fw && WORDS[fw].img) {
        friend = '<div class="intq__friend fade">' +
          '<span class="wall"><img src="' + esc(WORDS[fw].img) + '" alt="' + esc(WORDS[fw].art) + '"></span>' +
          '<span class="k">' + esc(S.friendKicker) + '</span><div class="w">' + esc(fw) + '</div>' +
          '<p class="b">' + esc(S.friendP) + '</p></div>';
      }
    }
    screens.intro.innerHTML = friend + '<div class="intq__intro fade">' +
      '<span class="k">' + esc(S.kicker) + '</span><h1>' + esc(S.introH) + '</h1><p class="b">' + esc(S.introP) + '</p>' +
      '<button type="button" class="btn" data-begin>' + esc(S.begin) + '</button></div>';
    screens.intro.querySelector('[data-begin]').addEventListener('click', begin);
  }
  function begin() {
    visit = draw(); answers = []; idx = 0;
    try { sessionStorage.setItem('intention_quiz', 'started'); } catch (e) {}
    try { window.klaviyo && window.klaviyo.push(['track', 'Started Intention Quiz', { source: 'theme_quiz', page: location.pathname }]); } catch (e) {}
    try { typeof fbq !== 'undefined' && fbq('trackCustom', 'QuizStart', { source: 'theme_quiz' }); } catch (e) {}
    renderQuestion(); show('question');
  }

  /* ---------- question ---------- */
  function renderQuestion() {
    var q = visit[idx], n = visit.length, pic = q.kind === 'picture';
    screens.question.innerHTML = '<div class="intq__prog"><i style="width:' + Math.round((idx / n) * 100) + '%"></i></div>' +
      '<div class="fade"><div class="intq__q"><span class="k">' + esc(String(S.qOf || '').replace('{n}', idx + 1).replace('{t}', n)) + '</span></div>' +
      '<h2>' + esc(L(q.q)) + '</h2>' +
      '<ul class="intq__ans' + (pic ? ' intq__ans--pic' : '') + '"></ul>' +
      '<div class="intq__nav">' + (idx > 0 ? '<button type="button" class="mt" data-back>' + esc(S.back) + '</button>' : '') + '</div></div>';
    var ul = screens.question.querySelector('.intq__ans');
    var order = shuffle(q.answers);
    ul.innerHTML = order.map(function (a, i) {
      var w = a.art ? wordByHandle(a.art) : null;
      if (pic && w && w.img) {
        return '<li><button type="button" data-i="' + i + '"><span class="wall"><img class="pic" src="' + esc(w.img) + '" alt="' + esc(a.text.en) + ', ' + esc(S.byClara) + '" loading="eager"></span>' +
          '<span class="t">' + esc(L(a.text)) + '</span></button></li>';
      }
      return '<li><button type="button" data-i="' + i + '">' + esc(L(a.text)) + '</button></li>';
    }).join('');
    Array.prototype.forEach.call(ul.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () { choose(order[parseInt(b.getAttribute('data-i'), 10)]); });
    });
    var back = screens.question.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () { if (idx > 0) { idx--; answers.pop(); renderQuestion(); } });
    var prog = screens.question.querySelector('.intq__prog i');
    requestAnimationFrame(function () { prog.style.width = Math.round(((idx + 1) / n) * 100) + '%'; });
  }
  function firstSentence(t) { var m = /^[\s\S]*?[.!?](?=\s|$)/.exec(t); return m ? m[0].trim() : t.trim(); }
  function wordByHandle(h) { var out = null; Object.keys(WORDS).forEach(function (t) { if (WORDS[t].handle === h) out = WORDS[t]; }); return out; }
  function choose(a) {
    answers[idx] = a;
    if (idx + 1 < visit.length) { idx++; renderQuestion(); show('question'); }
    else finish();
  }

  /* ---------- result ---------- */
  var result = null;
  function finish() {
    var sc = score(answers), hero = sc.top[0];
    var w = WORDS[hero] || {};
    var why = explain(answers, hero);
    /* ONE Word only since 2026-10-08 (Nils: "the quiz we build should not send word 2 and 3. Only one."):
       the result, localStorage int_quiz_words and Klaviyo carry the hero Word alone. */
    result = { words: [hero], hero: hero, answers: answers.slice() };
    try { localStorage.setItem('int_quiz_words', JSON.stringify([hero])); } catch (e) {}
    /* tell the bag, the PDP strip and the wishlist on THIS page (the real storage event only reaches other tabs) */
    try { window.dispatchEvent(new StorageEvent('storage', { key: 'int_quiz_words' })); } catch (e) {}
    try { if (typeof window.__intUpdatePPBundleStrip === 'function') window.__intUpdatePPBundleStrip(); if (typeof window.__intUpdateBundleStrip === 'function') window.__intUpdateBundleStrip(); } catch (e) {}
    try { typeof fbq !== 'undefined' && fbq('trackCustom', 'QuizComplete', { word: hero }); } catch (e) {}
    var line = why.length > 1 ? fmt(S.line2, L(why[0].echo), L(why[1].echo)) : fmt(S.line1, L(why[0].echo), '');
    var def = firstSentence(w.desc || '');
    screens.result.innerHTML =
      '<div class="fade ctr">' +
      '<div class="intq__stage">' +
        (w.img ? '<span class="wall"><img src="' + esc(w.img) + '" alt="' + esc(w.art) + ', ' + esc(S.byClara) + '"></span><span class="cap">' + esc(w.art) + ' · ' + esc(S.byClara) + '</span>' : '') +
        '<span class="k">' + esc(S.resultKicker) + '</span>' +
        (w.letter ? '<img class="intq__letter" src="' + esc(w.letter) + '" alt="' + esc(hero) + '">' : '<h2 class="intq__word">' + esc(hero) + '</h2>') +
      '</div>' +
      (def ? '<p class="intq__def">' + esc(def) + '</p>' : '') +
      '<p class="intq__why">' + line + '</p>' +
      '<div class="intq__btns">' +
        '<a class="btn" href="' + esc(w.wear || '#') + '">' + esc(String(S.wear || '').replace('{w}', hero)) + '</a>' +
        (w.pairing ? '<a class="btn btn--ghost" href="' + esc(w.pairing) + '">' + esc(S.pairing) + '</a>' : '') +
        '<button type="button" class="btn btn--ghost" data-share>' + esc(S.share) + '</button>' +
      '</div>' +
      '<div class="intq__msg" data-sharemsg></div>' +
      '<div class="intq__again"><button type="button" class="mt" data-again>' + esc(S.again) + '</button></div>' +
      '</div>' +
      '<div class="intq__keep fade" data-keep>' +
        '<span class="k">' + esc(S.keepKicker) + '</span><h3>' + esc(String(S.keepH || '').replace('{w}', hero)) + '</h3><p class="b">' + esc(S.keepP) + '</p>' +
        '<form class="intq__form" novalidate>' +
          '<input type="text" name="first_name" autocomplete="given-name" placeholder="' + esc(S.name) + '">' +
          '<input type="email" name="email" autocomplete="email" placeholder="' + esc(S.email) + '" required>' +
          '<label><input type="checkbox" name="consent"><span>' + esc(S.consent) + ' <a href="' + esc((CFG.root || '/') + 'policies/privacy-policy') + '">' + esc(S.privacy) + '</a></span></label>' +
          '<button type="submit" class="btn">' + esc(S.send) + '</button>' +
          '<div class="intq__msg" data-msg></div>' +
        '</form>' +
      '</div>';
    screens.result.querySelector('[data-share]').addEventListener('click', function () { share(hero, w); });
    screens.result.querySelector('[data-again]').addEventListener('click', function () { renderIntro(); show('intro'); });
    screens.result.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); submitEmail(this, hero, w); });
    show('result');
  }

  function share(hero, w) {
    var url = (CFG.quizUrl || location.href.split('?')[0]) + '?w=' + encodeURIComponent(w.key || hero.toLowerCase());
    var text = String(S.shareText || '').replace('{w}', hero);
    var msg = screens.result.querySelector('[data-sharemsg]');
    function fallback() {
      try { navigator.clipboard.writeText(text + ' ' + url).then(function () { msg.textContent = S.copied; }); } catch (e) { msg.textContent = url; }
      if (w.share) { var a = document.createElement('a'); a.href = w.share; a.download = 'intention-' + (w.key || 'word') + '.jpg'; a.target = '_blank'; a.rel = 'noopener'; a.className = 'mt'; a.textContent = S.saveImg; msg.appendChild(document.createElement('br')); msg.appendChild(a); }
    }
    if (navigator.share) {
      var data = { title: hero, text: text, url: url };
      if (w.share && navigator.canShare && window.File) {
        fetch(w.share).then(function (r) { if (!r.ok) throw 0; return r.blob(); }).then(function (b) {
          var f = new File([b], 'intention-' + (w.key || 'word') + '.jpg', { type: 'image/jpeg' });
          var d2 = { title: hero, text: text + ' ' + url, files: [f] };
          return navigator.share(navigator.canShare(d2) ? d2 : data);
        }).catch(function () { navigator.share(data).catch(function () {}); });
      } else navigator.share(data).catch(function () {});
    } else fallback();
  }

  /* ---------- Klaviyo: list XvVUZa + event, same company and list as the footer and the landing page ---------- */
  function submitEmail(form, hero, w) {
    var email = (form.email.value || '').trim(), name = (form.first_name.value || '').trim();
    var msg = form.querySelector('[data-msg]'), btn = form.querySelector('button[type=submit]');
    function err(t) { msg.textContent = t; msg.classList.add('err'); }
    msg.classList.remove('err');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return err(S.errEmail);
    if (!form.consent.checked) return err(S.errConsent);
    btn.disabled = true; btn.textContent = '...';
    var H = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };
    var base = 'https://a.klaviyo.com/client/';
    var profile = { type: 'profile', attributes: { email: email, first_name: name || undefined, locale: CFG.profileLocale || undefined, properties: { 'Word of Intention': hero } } };
    var props = { word_1: hero.toLowerCase(),
      first_name: name, locale: LOC, source: 'theme_quiz', artwork: w.art || '', quiz_url: CFG.quizUrl || location.href };
    result.answers.forEach(function (a, i) { props['answer_' + (i + 1)] = a.text.en + ' [' + a.words.join(', ') + ']'; });
    /* the card's answer line, in the visitor's language, for the result email (Nils 2026-10-06) */
    var whyE = explain(result.answers, result.hero);
    if (whyE[0]) props.why_1 = L(whyE[0].echo);
    if (whyE[1]) props.why_2 = L(whyE[1].echo);
    var sub = fetch(base + 'subscriptions/?company_id=' + CFG.company, { method: 'POST', headers: H, body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: profile } }, relationships: { list: { data: { type: 'list', id: CFG.list } } } } }) });
    var ev = fetch(base + 'events/?company_id=' + CFG.company, { method: 'POST', headers: H, body: JSON.stringify({ data: { type: 'event', attributes: { properties: props, metric: { data: { type: 'metric', attributes: { name: CFG.metric } } }, profile: { data: profile } } } }) });
    Promise.all([sub, ev]).then(function (rs) {
      if (rs[0].status < 300 && rs[1].status < 300) {
        var keep = screens.result.querySelector('[data-keep]');
        keep.innerHTML = '<span class="k">' + esc(S.keepKicker) + '</span><p class="intq__done">' + esc(String(S.sent || '').replace('{w}', hero)) + '</p>';
        try { window.klaviyo && window.klaviyo.push(['identify', { email: email, first_name: name }]); } catch (e) {}
        try { window.intTryonMember && window.intTryonMember(email, 'quiz'); } catch (e) {}
      } else { btn.disabled = false; btn.textContent = S.send; err(S.errNet); }
    }).catch(function () { btn.disabled = false; btn.textContent = S.send; err(S.errNet); });
  }

  renderIntro();
  show('intro');
})();
